/* n2-traccia.js — comportamento dei visitatori di Neimien (24/09/2026).
 *
 * Cosa fa ogni visita, prima del checkout: da quale annuncio e da quale app arriva, fin dove scorre,
 * quali blocchi della pagina vede davvero (almeno un secondo a schermo), cosa tocca (formati, test
 * capelli, FAQ, prima/dopo, foto, carrello, sconto, "Vai al pagamento") e quanto resta.
 * Va in tre posti: dashboard Neimien (POST /comportamento), Clarity (eventi ed etichette per filtrare le
 * registrazioni), nient'altro. NESSUN dato personale: id casuali di visita e di sessione, niente email.
 * Il checkout lo traccia il pixel «Neimien checkout», qui non serve.
 */
(function () {
  "use strict";
  var URL_T = "https://visiione.com/neimien/dashboard/comportamento";
  var coda = [], inviato = 0;

  function id(k, store) {
    try { var v = store.getItem(k); if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); store.setItem(k, v); } return v; }
    catch (e) { return "x" + Math.random().toString(36).slice(2); }
  }
  var VIS = id("nei_vis", localStorage), SES = id("nei_ses", sessionStorage);
  var q = new URLSearchParams(location.search);
  var ua = navigator.userAgent || "";
  var app = /Instagram/i.test(ua) ? "instagram" : /FBAN|FBAV|FB_IAB/i.test(ua) ? "facebook" : /TikTok|musical_ly|BytedanceWebview/i.test(ua) ? "tiktok" : "browser";
  var base = {
    vis: VIS, ses: SES, pagina: location.pathname,
    utm: q.get("utm_content") || q.get("utm_campaign") || null,
    fonte: q.get("utm_source") || (document.referrer ? (new URL(document.referrer)).hostname : "diretto"),
    app: app, mobile: window.innerWidth < 700,
    // 27/09/2026: prove nostre (?interno=1, vale per tutta la scheda) escluse dalle analisi
    interno: (function () { try { if (q.get("interno") === "1") sessionStorage.setItem("nei_interno", "1"); return sessionStorage.getItem("nei_interno") === "1"; } catch (e) { return q.get("interno") === "1"; } })()
  };
  var t0 = Date.now();

  function clarity(nome, etichette) {
    try {
      if (typeof window.clarity !== "function") return;
      window.clarity("event", nome);
      if (etichette) for (var k in etichette) window.clarity("set", k, String(etichette[k]));
    } catch (e) {}
  }
  function ev(nome, dati, perClarity) {
    var e = { e: nome, t: Math.round((Date.now() - t0) / 1000) };
    if (dati) for (var k in dati) e[k] = dati[k];
    coda.push(e);
    if (perClarity !== false) clarity(nome, perClarity || null);
  }
  function spedisci(finale) {
    if (!coda.length) return;
    var corpo = JSON.stringify({ base: base, eventi: coda.splice(0, 60) });
    try {
      if (finale && navigator.sendBeacon) { navigator.sendBeacon(URL_T, new Blob([corpo], { type: "text/plain" })); return; }
      fetch(URL_T, { method: "POST", headers: { "Content-Type": "text/plain" }, body: corpo, keepalive: true }).catch(function () {});
    } catch (e) {}
    inviato++;
  }
  setInterval(function () { spedisci(false); }, 5000);

  // — ingresso —
  ev("visita", { ref: document.referrer ? (new URL(document.referrer)).hostname : null }, { app: app, annuncio: base.utm || "nessuno" });

  // — scroll: soglie raggiunte e massimo —
  var maxScroll = 0, soglie = [25, 50, 75, 90];
  window.addEventListener("scroll", function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var p = Math.round(window.scrollY / h * 100);
    if (p > maxScroll) {
      maxScroll = p;
      while (soglie.length && p >= soglie[0]) { var s = soglie.shift(); ev("scroll_" + s, null, s >= 50 ? null : false); }
    }
  }, { passive: true });

  // — blocchi visti davvero (almeno 1 s con il 40% a schermo) —
  var NOMI = [
    [/^top$/, "hero"], [/^acquista$/, "prezzo_formati"], [/^test$/, "test_capelli"], [/^benefici$/, "problema"],
    [/Trascina/i, "prima_dopo"], [/^come-si-usa$/, "cinque_passaggi"], [/Guarda il trattamento/i, "video"],
    [/300/, "confronto_parrucchiere"], [/Se i tuoi capelli/i, "per_te"], [/^ingredienti$/, "ingredienti"],
    [/Tutto quello che serve/i, "cosa_ricevi"], [/Pioggia/i, "resistenza"], [/^faq$/, "faq"], [/Il prossimo mese/i, "chiusura"]
  ];
  function nomeBlocco(sec) {
    var h = sec.querySelector("h1,h2"), titolo = h ? h.textContent.trim() : "";
    for (var i = 0; i < NOMI.length; i++) if (NOMI[i][0].test(sec.id || "") || NOMI[i][0].test(titolo)) return NOMI[i][1];
    return sec.id || (titolo ? titolo.slice(0, 24).toLowerCase().replace(/[^a-z0-9]+/g, "_") : null);
  }
  if ("IntersectionObserver" in window) {
    var timer = new Map(), visti = {};
    var io = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        var n = v.target.getAttribute("data-blocco"); if (!n || visti[n]) return;
        if (v.isIntersecting) timer.set(n, setTimeout(function () { visti[n] = 1; ev("blocco", { b: n }, false); if (n === "prezzo_formati" || n === "prima_dopo" || n === "faq") clarity("visto_" + n); }, 1000));
        else { clearTimeout(timer.get(n)); }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll("main section, section").forEach(function (s) {
      var n = nomeBlocco(s); if (!n || s.getAttribute("data-blocco")) return;
      s.setAttribute("data-blocco", n); io.observe(s);
    });
  }

  // — clic che contano —
  document.addEventListener("click", function (e) {
    var t = e.target.closest ? e.target.closest("button, a, summary, [data-q], [data-src], [data-v]") : null;
    if (!t) return;
    var testo = (t.textContent || "").trim().replace(/\s+/g, " ").slice(0, 50);
    var sec = t.closest("[data-blocco]"), dove = sec ? sec.getAttribute("data-blocco") : null;
    if (t.hasAttribute("data-add")) return ev("aggiungi", { q: Number(t.getAttribute("data-add")) || 1, dove: dove }, { aggiunto: "si" });
    if (t.hasAttribute("data-buy-now")) return ev("acquista_subito", { dove: dove }, { aggiunto: "si" });
    if (t.hasAttribute("data-checkout")) return ev("vai_pagamento", null, { checkout: "si" });
    if (t.hasAttribute("data-q")) return ev("test_risposta", { r: testo }, false);
    if (t.hasAttribute("data-src")) return ev("foto", { dove: dove }, false);
    if (t.tagName === "SUMMARY") return ev("faq", { d: testo }, false);
    if (/flacon/i.test(testo) && dove === "prezzo_formati") return ev("formato", { f: /2/.test(testo) ? "2" : "1" }, false);
    if (/come funziona/i.test(testo)) return ev("come_funziona", null, false);
    if (/whatsapp|wa\.me/i.test(t.href || "")) return ev("whatsapp", { dove: dove }, false);
  }, true);

  // prima/dopo trascinato
  document.addEventListener("input", function (e) { if (e.target && e.target.type === "range") { ev("prima_dopo_trascinato", null, false); e.target.__tracciato = 1; } }, { once: true, capture: true });

  // — carrello, sconto, popup —
  var carrelloAperto = false;
  new MutationObserver(function () {
    var aperto = document.body.classList.contains("drawer-open");
    if (aperto && !carrelloAperto) ev("carrello_aperto", null, false);
    carrelloAperto = aperto;
  }).observe(document.body, { attributes: true, attributeFilter: ["class"] });
  document.addEventListener("submit", function (e) {
    if (e.target.closest && e.target.closest("[data-benvenuto]")) ev("sconto_carrello", null, { sconto: "carrello" });
    else if (e.target.closest && e.target.closest("#neiPop, .nei-pop, [id*=Pop]")) ev("sconto_popup", null, { sconto: "popup" });
  }, true);
  var pop = document.querySelector("#neiPop, .nei-pop-ov, [id^=neiPop]");
  if (pop) new MutationObserver(function () { if (pop.classList.contains("visible")) ev("popup_mostrato", null, false); })
    .observe(pop, { attributes: true, attributeFilter: ["class"] });

  // — uscita: tempo e scroll massimo —
  var attivo = 0, ultimo = Date.now();
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") { attivo += Date.now() - ultimo; ev("uscita", { s: Math.round(attivo / 1000), max: maxScroll }, false); spedisci(true); }
    else ultimo = Date.now();
  });
  window.addEventListener("pagehide", function () { spedisci(true); });

  // — test A/B del pre-checkout (27/09/2026): il ramo del carrello va su ogni evento; passi e campi toccati del
  //   pre-checkout arrivano da n2.js come evento «n2:traccia» (mai il contenuto dei campi) —
  try { fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { if (c && c.attributes && c.attributes._ab_precheckout) base.ab = c.attributes._ab_precheckout; }).catch(function () {}); } catch (e) {}
  document.addEventListener("n2:traccia", function (e) {
    var d = (e && e.detail) || {}; if (!d.e) return;
    if (d.e === "ab_ramo" && d.dati) base.ab = d.dati.r;
    ev(d.e, d.dati, d.e === "vai_pagamento" ? { checkout: "si" } : false);
  });
})();
